import router from "./router";
// get token from local storage
import { getToken, getRole } from "@/utils/auth";

// no redirect whitelist
const whiteList = ["/login", "/register", "/booking", "/lastminute"];

router.beforeEach((to, from, next) => {
  if (getToken()) {
    /* has token*/
    const role = getRole();
    if (to.path === "/" || to.path === "/login") {
      return next(role === "ROLE_ADMIN" ? "/admin" : "/business");
    }
    if (
      to.matched.some((route) => route.meta.adminAuth) &&
      role !== "ROLE_ADMIN"
    ) {
      return next("/");
    }
    return next();
  } else {
    /* has no token*/
    if (whiteList.some((it) => to.path.includes(it))) {
      next();
    } else {
      // redirect to dashboard in any case from login page
      // because after logout you can have unsuitable redirect for next login
      next(`/login`);
    }
  }
});



// WEBPACK FOOTER //
// ./src/permission.js